<div>
  <bottom-sheet-title [title]="'Create Tag'"></bottom-sheet-title>
  <div class="p-2 pb-0 flex items-center">
    <!-- <span class="mr-2">#</span> -->
    <input
      #myInput
      type="text"
      [value]="fullPath"
      (input)="updateName(fullPath, $event)"
      class="w-full p-2 rounded"
      placeholder='Tag name e.g.: "family/groceries"'
    />
  </div>

  <div class="p-2 flex w-full justify-between">
    <div
      class="p-4 bg-[var(--surface-container-color)] w-[49%] text-center rounded border border-[2px] border-[var(--surface-container-color)]"
      (click)="isPeriodic = false"
      [ngClass]="{
        'border-blue-500 text-blue-500': !isPeriodic
      }"
    >
      <span class="font-medium block text-sm">Fixed</span>
      <span class="text-sm">Great for accounts and one-time projects</span>
    </div>
    <div
      class="p-4 bg-[var(--surface-container-color)] w-[49%] text-center rounded border border-[2px] border-[var(--surface-container-color)]"
      (click)="isPeriodic = true"
      [ngClass]="{
        'border-blue-500 text-blue-500': isPeriodic
      }"
    >
      <span class="font-medium block text-sm">
        <span>Periodic</span>
        <pro-badge
          [disableDialog]="true"
          *ngIf="!authService.isPro"
          [tooltip]="null"
          class="ml-1 align-middle"
        ></pro-badge>
      </span>
      <span class="text-sm">Great for monthly budgets and income goals</span>
    </div>
  </div>

  <bottom-sheet-controls
    (onCancel)="_bottomSheetRef.dismiss()"
    (onSubmit)="createTag()"
    [submitText]="isPeriodic && !authService.isPro ? 'Get Pro' : 'Create'"
    [isSubmitting]="isSubmitting"
  ></bottom-sheet-controls>
</div>
